import React from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Button } from '@material-ui/core';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { BODY_TERMINOS_P1, BODY_TERMINOS_P2, CLOSE_MODAL_FINAL, SALVAR_STEP } from "../../pages/empresas/constants";
import { getFormFiles } from "../../pages/empresas/selectors";

function Componet() {
    const dispatch = useDispatch();
    const formFiles = useSelector(getFormFiles);
    const [aceptaTerminos, setAceptaTerminos] = React.useState(false);
    const submitFinalForm = (value) => dispatch({ type: SALVAR_STEP, value });
    const closeModalFinal = (value) => dispatch({ type: CLOSE_MODAL_FINAL, value });
    return (
        <Dialog
            open
            className="modal-final-form"
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <div className="finalForm">
                <h2>Términos y condiciones</h2>
                <p className="encabezado-terminos">Lea atentamente y marque la casilla si esta de acuerdo con los términos y condiciones</p>
                <p className="encabezado-terminos">Autorizaciones.</p>
                <p className="body-punto-terminos">1. Autorización de tratamiento de datos personales.</p>
                <p className="body-terminos">{BODY_TERMINOS_P1}</p>
                <p className="body-punto-terminos">2. Autorización términos y condiciones.</p>
                <p className="body-terminos">{BODY_TERMINOS_P2}</p>
                <div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={aceptaTerminos}
                                onChange={() => setAceptaTerminos(!aceptaTerminos)}
                            />
                        }
                        label={`Acepto términos y condiciones`}
                    />
                </div>
            </div>
            <DialogActions>
                <Button
                    className='buttonFinalizar'
                    variant="text"
                    color="default"
                    onClick={() => closeModalFinal()}
                >
                    Cancelar
                </Button>
                <Button
                    className='buttonFinalizar'
                    variant="text"
                    color="default"
                    onClick={() => submitFinalForm({ formFiles, final: true, aceptaTerminos })}
                >
                    Aceptar
                </Button>

            </DialogActions>
        </Dialog>
    );
}

export const ComponetTerminos = connect(
    null,
    null
)(Componet);